import logo from './logo.svg';

export const settings = {
    "title": "Genius Store",
    "apiUrl": "https://api.montorfano.geniuscloud.it/api",
    "ckdPath": "https://api.montorfano.geniuscloud.it/",
    "tinyKey": "uxd8thxx2a96p0tne20wyfcdx7zvpyprm38j5q5w9qqauy2p",
    "googleMapKey": "AIzaSyDwVSRwXezXuTLG8-VAe1KfNKo7zLPlYJQ",
    "config": {
        "limit": 50,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "configEntity": {
        "customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "supplier": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "sales_agent": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        }
    },
    "theme": {
        "siderbarIconColor": 'rgba(233,236,239,.5)'
    },
    "logo": logo,
    "data_print": {
        "name": 'Fratelli Montorfano S.r.l.',
        "address": 'Via per Cantù, 40 22070 Capiago Intimiano CO',
        "phone": 'Tel: 031 460160',
        "fax": '',
        "email": 'Email: info@fmminterior.it',
        "iva": 'P.IVA: 00291710135',
        "cf": 'C.F.: 00291710135',
        "website": 'Sito Web: www.fmminterior.it',
    },
    "dati_pagamento": {
        "iban": "IBAN: IT 47 X 08430 51081 000000140249",
        "bic": "",
        "banca": "Cassa Rurale ed Artigiana di Cantù BCC",
        "intestatario": "Fratelli Montorfano S.r.l.",
    },
    "iva_label": 'esclusa',
    "iva_esclusa": true,
    "sconti": true,
    "usingCache": false
}